
import { Component, Vue } from 'vue-property-decorator';
import { SkeletonLoader } from '@warrenbrasil/nebraska-web';

@Component({
  name: 'PortfoliosToInvestCardLoader',
  components: { SkeletonLoader }
})
export default class PortfoliosToInvestCardLoader extends Vue {}
